import UserListPageReducer from './UserListPageReducer';

export default from './UserListPageContainer';

export const UserListPageReducers = {
  UserListPageReducer,
};
